import { debounce } from './utils';

type MovePopoverProps = {
  selector: string;
  targetSelector: string;
  position: InsertPosition;
};

const selector = '.Product__OffScreen',
  targetSelector = 'body',
  position = 'beforeend';

function hidePopover() {
  const popover = document.querySelector(selector);

  if (!popover) return;

  const closePopoverButton = popover.querySelector<HTMLButtonElement>(
    "[data-action='close-popover']",
  );

  if (!closePopoverButton) return;

  closePopoverButton.click();

  const pageOverlay = document.querySelector('.PageOverlay');

  if (!pageOverlay) return;

  pageOverlay.classList.remove('is-visible');
}

function moveProductPopover({ selector, targetSelector, position }: MovePopoverProps) {
  const popover = document.querySelector(selector);
  if (!popover) return;
  const target = document.querySelector(targetSelector);
  if (!target) return;
  target.insertAdjacentElement(position, popover);

  window.addEventListener('resize', debounce(hidePopover, 200));
}

if (document.readyState !== 'complete') {
  document.addEventListener('DOMContentLoaded', () => {
    moveProductPopover({
      selector,
      targetSelector,
      position,
    });
  });
} else {
  moveProductPopover({
    selector,
    targetSelector,
    position,
  });
}
